import { useState } from 'react';
import styled from 'styled-components';

import { InputSearch, InputSearchProps } from 'ui/inputs';
import { spacing } from 'ui/theme';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';

export const DEBOUNCE_TIMEOUT_MS = 500;

const StyledSearchInput = styled(InputSearch)`
  width: ${spacing.x16};
`;

type DebouncedSearchInputProps = InputSearchProps & {
  onChange: (value: string) => void;
};

export const DebouncedSearchInput = ({
  onChange: onDebouncedChange,
  value: debouncedValue,
  ...props
}: DebouncedSearchInputProps) => {
  const [value, onChange] = useState(debouncedValue);
  useDebouncedEffect(
    () => {
      onDebouncedChange(value);
    },
    [value],
    { debounceTimeout: DEBOUNCE_TIMEOUT_MS },
  );

  return <StyledSearchInput value={value} onChange={onChange} {...props} />;
};
